"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Basket_module_1 = require("./modules/Basket.module");
const Checkout_module_1 = require("./modules/Checkout.module");
const loadBasketMenuItemModule = () => ({
    hasRouter: false,
    modules: [(0, Basket_module_1.default)(), (0, Checkout_module_1.default)()],
});
exports.default = loadBasketMenuItemModule;
